export default __webpack_public_path__ + "transfix-maps/icons/P-newWave.7c809c65c711eeafc1c23f8149badbc4.png";